export type Environment = "production" | "uat" | "stage" | "dev" | "sandbox" | "demo" | "e2e" | "local";

export const getEnvironment = (): Environment => {
  const hostname = window.location.hostname;

  // Match against known hostname prefixes from .env files
  // e.g. stage-coronis.coronisops.com, dev-coronis.coronisops.com, etc.
  if (hostname.startsWith("stage-") || hostname.includes("stage.")) return "stage";
  if (hostname.includes("-uat.") || hostname.includes("uat.")) return "uat";
  if (hostname.startsWith("dev-") || hostname.includes("dev.")) return "dev";
  if (hostname.startsWith("sandbox-") || hostname.includes("sandbox.")) return "sandbox";
  if (hostname.startsWith("demo-") || hostname.includes("demo.")) return "demo";

  // Local / E2E environments
  if (hostname === "localhost" || hostname.startsWith("127.") || hostname.includes(".sslip.io")) {
    // E2E uses localhost with the API at localhost:9999
    const apiUrl = import.meta.env.VITE_API_SERVER_URL ?? "";
    if (apiUrl.includes("localhost") && !hostname.includes(".sslip.io")) return "e2e";
    return "local";
  }

  return "production";
};

/** Returns true for non-production environments (dev, uat, stage, sandbox, local, e2e). */
export const isNonProductionEnvironment = (): boolean => {
  const env = getEnvironment();
  return env !== "production" && env !== "demo";
};

export const ENV_CONFIG: Record<
  Environment,
  { label: string; color: "default" | "warning" | "info" | "secondary" | "success" | "error" }
> = {
  production: { label: "PROD", color: "default" },
  uat: { label: "UAT", color: "warning" },
  stage: { label: "STAGE", color: "warning" },
  dev: { label: "DEV", color: "info" },
  sandbox: { label: "SANDBOX", color: "secondary" },
  demo: { label: "DEMO", color: "success" },
  e2e: { label: "E2E", color: "secondary" },
  local: { label: "LOCAL", color: "secondary" },
};
